import * as Yup from "yup";
const noSpaceMessage = "No spaces allowed.";
// const maxWords = 20;
// const tooManyWordsMessage = `First name can have a maximum of ${maxWords} words.`;
// const maxLengthFirstMessage =
//   "First name should be less than or equal to 20 characters.";
// const maxLengthLastMessage =
//   "Last name should be less than or equal to 20 characters.";
// const maxLengthGroupMessage =
//   "It should be less than or equal to 30 characters.";
// const maxLengthFirstMessage1 =
//   "It should be less than or equal to 50 characters.";

// const noInitialSpace = (value) => !value?.startsWith(" ");
// const noInitialSpace = (value: string) => !value || value.trimStart() === value;
const emailField = {
  email: Yup.string()
    .required("Email address is required.")
    .trim()
    .email("Please enter valid email address.")
    .test("is-valid-email", "Please enter valid email address.", (value) => {
      // This will check if the email contains at least one dot after the '@'
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value);
    }), // Check for a valid email structure
};
const passwordValidation = Yup.string()
  .required("Password is required.")
  .min(8, "Password must be at least 8 characters")
  .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
    "Password must contain at least 8 characters, one uppercase, one lowercase and a number"
  );
const forgotPasswordSchema = Yup.object({
  email: Yup.string()
    .trim()
    .required("Email is required.")
    // .matches(/^\S+$/, noSpaceMessage)
    .email("Please enter valid email address."),
});
const signinSchema = Yup.object({
  ...emailField,
  email: Yup.string().required("Email is required."),
});

const otpVerifySchema = Yup.object({
  otp: Yup.string().required("Otp is required."),
});

/**
 * Login Validation Schema
 */
const loginSchema = Yup.object({
  email: Yup.string()

    .trim()
    .required("Email is required.")
    // .matches(/^\S+$/, noSpaceMessage)
    .email("Please enter valid email address."),

  password: Yup.string().required("Password is required."),
});
/**
 * reset Validation Schema
 */
// const resetPasswordSchema = Yup.object({

//   newPassword: passwordValidation
//     .notOneOf(
//       [Yup.ref("oldPassword"), null],
//       "New Password cannot be the same as Old Password"
//     )
//     .required("New Password is required."),
// });

const resetPasswordSchema = Yup.object({
  newPassword: Yup.string()
    .required("Password is required.")
    .min(8, "Password must be at least 8 characters.")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      "Password must contain at least 8 characters, one uppercase, one lowercase and a number."
    ),
  confirmPassword: Yup.string()
    .required("Confirm Password is required.")
    .min(8, "Password must be at least 8 characters.")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      "Password must contain at least 8 characters, one uppercase, one lowercase and a number."
    )
    .oneOf(
      [Yup.ref("newPassword")],
      "Password and confirm password do not match."
    ),
});
export const llcSchema = Yup.object().shape({
  first_name: Yup.string()
    .trim()
    .required("First name is required")
    .matches(
    /^(?=.*\p{L})[\p{L}\s'-]+$/u,
    "Please enter a valid first name"
  )
    .max(50, "First name must not exceed 50 characters"),

  middle_name: Yup.string()
    .trim()
    // .matches(/^[^0-9][a-zA-Z0-9]*$/, "Please enter valid middle name ")
    // .min(3, "Middle name is required")
    .max(50, "Middle name must not exceed 50 characters")
    .optional(),
  last_name: Yup.string()
    .trim()
    // .matches(/^[^0-9][a-zA-Z0-9]*$/, "Please enter valid last name ")
    // .min(3, "Last name is required")
    // .max(50, "Last name must not exceed 50 characters")
    .required("Last name is required"),
  email: Yup.string()
    .required("Email address is required.")
    .trim()
    .email("Please enter valid email address.")
    .test("is-valid-email", "Please enter valid email address.", (value) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value);
    }),

  phone_number: Yup.string()
    .matches(/^\+?\d{7,15}$/, "Invalid phone number")
    .required("Phone number is required"),
  address: Yup.string()
    .trim()
    // .matches(/^[^0-9][a-zA-Z0-9]*$/, "Please enter valid address name")
    .required("Address is required"),
  country: Yup.string().required("Country is required"),

  state: Yup.string()
    .trim()
    // .matches(/^[^0-9][a-zA-Z0-9]*$/, "Please enter valid state name")
    .required("State is required"),
  city: Yup.string()
    .trim()
    .matches(/^[a-zA-Z\s]+$/, "Please enter a valid city name")
    .required("City is required"),
  zip_code: Yup.string()
    .trim()
    .required("Zipcode is required.")
    .min(3, "Zipcode must be at least 3 characters long."),
  // .max(8, "Zipcode must be no more than 8 ."),
  company_members: Yup.string().required(
    "Company members selection is required"
  ),
  company_type: Yup.string().required("Company type is required"),
  preferred_name_1: Yup.string()
    .trim()
    // .matches(/^[^0-9][a-zA-Z0-9]*$/, "Please enter valid preferred name")
    .required("Preferred Name 1 is required"),
  preferred_name_2: Yup.string().trim().optional(),
  preferred_name_3: Yup.string().trim().optional(),
  industry_type: Yup.string().required("Industry type is required"),
  business_description: Yup.string().when(
    "industry_type",
    (industry_type: any, schema) => {
      return industry_type === 13
        ? schema.required("Business description is required ")
        : schema.notRequired();
    }
  ),
  genrating_revenue: Yup.boolean().required(
    "Generating revenue selection is required"
  ),
  annual_revenue: Yup.string().when("genrating_revenue", {
    is: true,
    then: (schema) => schema.required("Annual revenue  is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  employees_count: Yup.string().required("Employee count  is required"),
  is_us_company: Yup.boolean().required("Please select an option"),
  website_name: Yup.string()
    .trim()
    .matches(
      /^(https?:\/\/|www\.)[^\s]*\.(com|in)(\/[^\s]*)?$/i,
      "Invalid URL format. URL must start with http://, https://, or www., and end with .com or .in"
    )
    // .matches(
    //   /^(https?:\/\/|www\.)[^\s$.?#].[^\s]*$/i,
    //   "Invalid URL format . URL must start with  http://, https://, or www."
    // )
    .optional(),
  scan_passport: Yup.mixed().required("Scan passport is required "),
});

export const memberSchema = Yup.object().shape({
  member_first_name: Yup.string()
    .trim()
    .required("First name is required")
      .matches(
    /^(?=.*\p{L})[\p{L}\s'-]+$/u,
    "Please enter a valid first name"
  )
    .max(50, "First name must not exceed 50 characters"),

  member_middle_name: Yup.string()
    .trim()
    .max(50, "Middle name must not exceed 50 characters")
    .optional(),

  member_last_name: Yup.string()
    .trim()
    .required("Last name is required")
    .max(50, "Last name must not exceed 50 characters"),

  member_email: Yup.string()
    .required("Email address is required.")
    .trim()
    .email("Please enter valid email address.")
    .test("is-valid-email", "Please enter valid email address.", (value) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value ?? "");
    }),

  member_phone_number: Yup.string()
    .matches(/^\+?\d{7,15}$/, "Invalid phone number")
    .required("Phone number is required"),

  member_address: Yup.string()
    .trim()
    .required("Address is required"),

  member_city: Yup.string()
    .trim()
    .matches(/^[a-zA-Z\s]+$/, "Please enter a valid city name")
    .required("City is required"),

  member_state: Yup.string()
    .trim()
    .required("State is required"),

  member_zip_code: Yup.string()
    .trim()
    .required("Zip code is required.")
    .min(3, "Zip code must be at least 3 characters long."),

  member_country: Yup.string()
    .required("Country is required"),

  member_attachment: Yup.mixed()
    .required("Passport is required"),
});

export const agentSchema = Yup.object().shape({
  first_name: Yup.string()
    .trim()
     .matches(
    /^(?=.*\p{L})[\p{L}\s'-]+$/u,
    "Please enter a valid first name"
  )

    .max(50, "First name must not exceed 50 characters")
    .required("First name is required"),

  last_name: Yup.string().trim().required("Last name is required"),
  email: Yup.string()
    .required("Email address is required.")
    .trim()
    .email("Please enter valid email address.")
    .test("is-valid-email", "Please enter valid email address.", (value) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value);
    }),
});
export {
  forgotPasswordSchema,
  loginSchema,
  signinSchema,
  resetPasswordSchema,
  otpVerifySchema,
};

// Validation schema
export const validationSchema = Yup.object({
  secretKey: Yup.string()
    .min(8, "Key must be at least 8 characters")
    .required("Secret key is required"),
  accountId: Yup.string()
    .min(8, "ID must be at least 8 characters")
    .required("Account ID is required"),
});

export const taxFilingSchema = Yup.object({
  tax_filing: Yup.string().required("Please select LLC or C-Corp"),
  has_itin: Yup.boolean().when("tax_filing", {
    is: (val: string) =>
      val === "LLC+$200.00" ||
      val === "Empty Filing I didnt have any revenue-$200.00",
    then: (schema) => schema.required("Please select an option"),
    otherwise: (schema) => schema.notRequired(),
  }),
  consent: Yup.boolean().oneOf([true], "Privacy policy is required."),
  multi_members: Yup.boolean().when("tax_filing", {
    is: (val: string) => val === "LLC+$200.00",
    then: (schema) => schema.required("Please select an option"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const SinglememberFormSchema = Yup.object({
  // Personal Information
  name_surname: Yup.string()
    .trim()
    .required("Name and surname is required")
    .min(2, "Name must be at least 2 characters"),
  email: Yup.string()
    .required("Email is required")
    .trim()
    .email("Please enter valid email address")
    .test("is-valid-email", "Please enter valid email address.", (value) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value);
    }),
  date_of_birth: Yup.string().trim().required("Date of birth is required"),
  phone_number: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Phone number is required")
    .matches(/^\+?[\d\s\-\(\)]{7,20}$/, "Minimum 7 digits are required"),
  country: Yup.string().required("Country is required"),

  // Business Details
  working_outside_us: Yup.string().required("Working outside US is required"),
  working_within_us: Yup.string().required("Working within US is required"),
  business_address: Yup.string()
    .trim()
    .required("Business address is required"),
  nature_of_business: Yup.string()
    .trim()
    .required("Nature of business is required"),

  // File uploads
  passport_scan: Yup.mixed()
    .nullable() // <— allow null values
    .optional() // <— allow undefined values
    .test("file-or-string", "Passport scan is required", (value) => {
      if (value === undefined || value === null || value === "") {
        return true; // ✅ don't throw if optional
      }
      return value instanceof File || typeof value === "string";
    }),

  passport_scan_string: Yup.string().optional(),
  ein_document_string: Yup.string().optional(),
  itin_document_string: Yup.string().optional(),
  company_formation_document_string: Yup.string().optional(),

  company_formation_document: Yup.array()
    .min(1, "At least one company document is required")
    .test("valid-files", "Invalid file(s)", (files) => {
      if (!files) return false;
      return files.every(
        (file) =>
          file instanceof File ||
          typeof file === "string" ||
          (file && file.document_file_url)
      );
    }),

  ein_document: Yup.mixed().test(
    "file-or-string",
    "EIN document is required",
    (value) => {
      if (Array.isArray(value)) return value.length > 0;
      return value instanceof File || typeof value === "string";
    }
  ),

  itin_document: Yup.array()
    .nullable() // <— allow null values
    .optional() // <— allow undefined values
    .test("valid-files", "Invalid file(s)", (files) => {
      if (!files || files.length === 0) return true; // ✅ allow empty
      return files.every(
        (file) =>
          file instanceof File ||
          typeof file === "string" ||
          (file && file.document_file_url)
      );
    }),

  // Business Income (required)
  gross_income: Yup.string()
    .required("Gross income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  amount_of_returns: Yup.string()
    .required("Amount of returns is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  cost_of_goods_sold: Yup.string()
    .required("Cost of goods sold is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),

  // Business Expenses (required)
  advertising: Yup.string()
    .required("Advertising is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  commissions_fees: Yup.string()
    .required("Commissions and fees is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  contract_labor: Yup.string()
    .required("Contract labor is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  office_expenses: Yup.string()
    .required("Office expenses is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  legal_professional: Yup.string()
    .required("Legal professional is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  insurance: Yup.string()
    .required("Insurance is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  interest_bank: Yup.string()
    .required("Interest bank is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  pension_profit_sharing: Yup.string()
    .required("Pension profit sharing is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  rent_lease_vehicles: Yup.string()
    .required("Rent lease vehicles is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  repairs_maintenance: Yup.string()
    .required("Repairs maintenance is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  supplies_materials: Yup.string()
    .required("Supplies materials is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  supplies_stationary: Yup.string()
    .required("Supplies stationary is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  taxes_licenses: Yup.string()
    .required("Taxes licenses is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  travel_meals: Yup.string()
    .required("Travel meals is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  utilities: Yup.string()
    .required("Utilities is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  wages: Yup.string()
    .required("Wages is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  other_business: Yup.string()
    .required("Other business is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),

  // Personal Income (required)
  interest_income: Yup.string()
    .required("Interest income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  tax_exempt_interest: Yup.string()
    .required("Tax exempt interest is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  qualified_dividends: Yup.string()
    .required("Qualified dividends is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  taxable_refunds: Yup.string()
    .required("Taxable refunds is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  capital_gain_loss: Yup.string()
    .required("Capital gain loss is required")
    .matches(/^-?\$?\d*\.?\d*$/, "Must be a valid number (can be negative)"),
  other_gains_losses: Yup.string()
    .required("Other gains losses is required")
    .matches(/^-?\$?\d*\.?\d*$/, "Must be a valid number (can be negative)"),
  ira_distributions: Yup.string()
    .required("IRAs, pensions and annuities is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  pensions_annuities: Yup.string()
    .required("Pensions annuities is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  farm_income_loss: Yup.string()
    .required("Farm income loss is required")
    .matches(/^-?\$?\d*\.?\d*$/, "Must be a valid number (can be negative)"),
  unemployment_compensation: Yup.string()
    .required("Unemployment compensation is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  other_income: Yup.string()
    .required("Other income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),

  // Contributions and Distributions (required)
  total_contributions: Yup.string()
    .required("Total contributions is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  total_distributions: Yup.string()
    .required("Total distributions is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
});

export const CCorpMemberFormSchema = Yup.object({
  // Personal Information
  name_surname: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Name and surname is required")
    .min(2, "Name must be at least 2 characters"),
  email: Yup.string()
    .required("Email is required")
    .transform((value) => (value ? String(value).trim() : ""))
    .email("Please enter valid email address")
    .test("is-valid-email", "Please enter valid email address.", (value) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value);
    }),
  date_of_birth: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Date of birth is required"),
  phone_number: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Phone is required")
    .matches(/^\+?[\d\s\-\(\)]{7,20}$/, "Minimum 7 digits are required"),
  country: Yup.string().required("Country is required"),

  // Business Details
  additional_members: Yup.string().required(
    "Number of additional members is required"
  ),
  partnership_structure: Yup.string()
    .optional()
    .transform((value) => (value ? String(value).trim() : "")),

  business_address: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Business address is required"),
  nature_of_business: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Nature of business is required"),
  // ein: Yup.string()
  //   .transform((value) => value ? String(value).trim() : '')
  //   .required("EIN is required"),
  // itin: Yup.string()
  //   .transform((value) => value ? String(value).trim() : '')
  //   .optional(),
  // File uploads
  passport_scan: Yup.mixed()
    .nullable() // <— allow null values
    .optional() // <— allow undefined values
    .test("file-or-string", "Passport scan is required", (value) => {
      if (value === undefined || value === null || value === "") {
        return true; // ✅ don't throw if optional
      }
      return value instanceof File || typeof value === "string";
    }),

  passport_scan_string: Yup.string().optional(),
  ein_document_string: Yup.string().optional(),
  itin_document_string: Yup.string().optional(),
  company_formation_document_string: Yup.string().optional(),

  company_formation_document: Yup.array()
    .min(1, "At least one company document is required")
    .test("valid-files", "Invalid file(s)", (files) => {
      if (!files) return false;
      return files.every(
        (file) =>
          file instanceof File ||
          typeof file === "string" ||
          (file && file.document_file_url)
      );
    }),

  ein_document: Yup.mixed().required("EIN document is required"),

  itin_document: Yup.array()
    .nullable() // <— allow null values
    .optional() // <— allow undefined values
    .test("valid-files", "Invalid file(s)", (files) => {
      if (!files || files.length === 0) return true; // ✅ allow empty
      return files.every(
        (file) =>
          file instanceof File ||
          typeof file === "string" ||
          (file && file.document_file_url)
      );
    }),

  // Business Income (required)
  gross_income: Yup.string()
    .required("Gross income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  amount_returns: Yup.string()
    .required("Amount of returns is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  cost_of_goods_sold: Yup.string()
    .required("Cost of goods sold is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),

  // Business Expenses (required)
  advertising: Yup.string()
    .required("Advertising is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  commissions_fees: Yup.string()
    .required("Commissions and fees is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  contract_labor: Yup.string()
    .required("Contract labor is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  insurance: Yup.string()
    .required("Insurance is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  interest_bank: Yup.string()
    .required("Interest bank is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  legal_professional: Yup.string()
    .required("Legal professional is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  office_expenses: Yup.string()
    .required("Office expenses is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  pension_profit_sharing: Yup.string()
    .required("Pension profit sharing is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  rent_lease_vehicles: Yup.string()
    .required("Rent lease vehicles is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  repairs_maintenance: Yup.string()
    .required("Repairs maintenance is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  supplies_materials: Yup.string()
    .required("Supplies materials is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  supplies_stationary: Yup.string()
    .required("Supplies stationary is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  taxes_licenses: Yup.string()
    .required("Taxes licenses is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  travel_meals: Yup.string()
    .required("Travel meals is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  utilities: Yup.string()
    .required("Utilities is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  wages: Yup.string()
    .required("Wages is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  other_business: Yup.string()
    .required("Other business is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),

  // Personal Income (required)
  personal_gross_income: Yup.string()
    .required("Personal gross income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  interest_income: Yup.string()
    .required("Interest income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  tax_exempt_interest: Yup.string()
    .required("Tax exempt interest is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  qualified_dividends: Yup.string()
    .required("Qualified dividends is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  taxable_refunds: Yup.string()
    .required("Taxable refunds is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  scholarship_fellowship_grants: Yup.string()
    .required("Scholarship fellowship grants is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  capital_gain_loss: Yup.string()
    .required("Capital gain loss is required")
    .matches(/^-?\$?\d*\.?\d*$/, "Must be a valid number (can be negative)"),
  other_gains_losses: Yup.string()
    .required("Other gains losses is required")
    .matches(/^-?\$?\d*\.?\d*$/, "Must be a valid number (can be negative)"),
  ira_distributions: Yup.string()
    .required("IRAs, pensions and annuities is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  pensions_annuities: Yup.string()
    .required("Pensions annuities is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  farm_income_loss: Yup.string()
    .required("Farm income loss is required")
    .matches(/^-?\$?\d*\.?\d*$/, "Must be a valid number (can be negative)"),
  unemployment_compensation: Yup.string()
    .required("Unemployment compensation is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  other_income: Yup.string()
    .required("Other income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),

  // Additional Description (optional)
});

export const MultimemberFormSchema = Yup.object({
  // Personal Information
  name_surname: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Name and surname is required")
    .min(2, "Name must be at least 2 characters"),
  email: Yup.string()
    .required("Email is required")
    .transform((value) => (value ? String(value).trim() : ""))
    .email("Please enter valid email address")
    .test("is-valid-email", "Please enter valid email address.", (value) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value);
    }),
  date_of_birth: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Date of birth is required"),
  phone_number: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Phone is required")
    .matches(/^\+?[\d\s\-\(\)]{7,20}$/, "Minimum 7 digits are required"),
  country: Yup.string().required("Country is required"),
  current_us_visa: Yup.string().optional(),
  other_visa: Yup.string().optional(),
  us_address: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .optional(),
  foreign_address: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .optional(),
  itin: Yup.string().optional(),
  ssn: Yup.string().optional(),

  // Business Details
  additional_members: Yup.string().required(
    "Number of additional members is required"
  ),
  partnership_structure: Yup.string().optional(),
  business_address: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Business address is required"),
  nature_of_business: Yup.string()
    .transform((value) => (value ? String(value).trim() : ""))
    .required("Nature of business is required"),
  passport_scan: Yup.mixed()
    .nullable() // <— allow null values
    .optional() // <— allow undefined values
    .test("file-or-string", "Passport scan is required", (value) => {
      if (value === undefined || value === null || value === "") {
        return true; // ✅ don't throw if optional
      }
      return value instanceof File || typeof value === "string";
    }),

  passport_scan_string: Yup.string().optional(),
  ein_document_string: Yup.string().optional(),
  itin_document_string: Yup.string().optional(),
  company_formation_document_string: Yup.string().optional(),
  company_formation_document: Yup.array()
    .min(1, "At least one company document is required")
    .test("valid-files", "Invalid file(s)", (files) => {
      if (!files) return false;
      return files.every(
        (file) =>
          file instanceof File ||
          typeof file === "string" ||
          (file && file.document_file_url)
      );
    }),

  ein_document: Yup.mixed().test(
    "file-or-string",
    "EIN document is required",
    (value) => {
      if (Array.isArray(value)) return value.length > 0;
      return value instanceof File || typeof value === "string";
    }
  ),

  itin_document: Yup.array()
    .nullable() // <— allow null values
    .optional() // <— allow undefined values
    .test("valid-files", "Invalid file(s)", (files) => {
      if (!files || files.length === 0) return true; // ✅ allow empty
      return files.every(
        (file) =>
          file instanceof File ||
          typeof file === "string" ||
          (file && file.document_file_url)
      );
    }),

  // Business Income (required)
  gross_income: Yup.string()
    .required("Gross income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  amount_returns: Yup.string()
    .required("Amount of returns is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  cost_of_goods_sold: Yup.string()
    .required("Cost of goods sold is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),

  // Business Expenses (required)
  advertising: Yup.string()
    .required("Advertising is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  commissions_fees: Yup.string()
    .required("Commissions and fees is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  contract_labor: Yup.string()
    .required("Contract labor is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  insurance: Yup.string()
    .required("Insurance is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  interest_bank: Yup.string()
    .required("Interest bank is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  legal_professional: Yup.string()
    .required("Legal professional is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  office_expenses: Yup.string()
    .required("Office expenses is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  pension_profit_sharing: Yup.string()
    .required("Pension profit sharing is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  rent_lease_vehicles: Yup.string()
    .required("Rent lease vehicles is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  repairs_maintenance: Yup.string()
    .required("Repairs maintenance is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  supplies_materials: Yup.string()
    .required("Supplies materials is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  supplies_stationary: Yup.string()
    .required("Supplies stationary is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  taxes_licenses: Yup.string()
    .required("Taxes licenses is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  travel_meals: Yup.string()
    .required("Travel meals is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  utilities: Yup.string()
    .required("Utilities is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  wages: Yup.string()
    .required("Wages is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  other_business: Yup.string()
    .required("Other business is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),

  // Personal Income (required)
  personal_gross_income: Yup.string()
    .required("Personal gross income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  interest_income: Yup.string()
    .required("Interest income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  tax_exempt_interest: Yup.string()
    .required("Tax exempt interest is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  qualified_dividends: Yup.string()
    .required("Qualified dividends is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  taxable_refunds: Yup.string()
    .required("Taxable refunds is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  scholarship_fellowship_grants: Yup.string()
    .required("Scholarship fellowship grants is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  capital_gain_loss: Yup.string()
    .required("Capital gain loss is required")
    .matches(/^-?\$?\d*\.?\d*$/, "Must be a valid number (can be negative)"),
  other_gains_losses: Yup.string()
    .required("Other gains losses is required")
    .matches(/^-?\$?\d*\.?\d*$/, "Must be a valid number (can be negative)"),
  ira_distributions: Yup.string()
    .required("IRAs, pensions and annuities is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  pensions_annuities: Yup.string()
    .required("Pensions annuities is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  farm_income_loss: Yup.string()
    .required("Farm income loss is required")
    .matches(/^-?\$?\d*\.?\d*$/, "Must be a valid number (can be negative)"),
  unemployment_compensation: Yup.string()
    .required("Unemployment compensation is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
  other_income: Yup.string()
    .required("Other income is required")
    .matches(/^\$?\d*\.?\d*$/, "Must be a valid number"),
});
